








































































































import {Component, Ref, Vue} from "vue-property-decorator"
import DatePicker from "@/components/DatePicker.vue"
import ErrorMessage from "@/components/ErrorMessage.vue"
import moment from "moment"
import {vxm} from "@/store"
import {Validation} from "@/lib/Validation"
import {FlushMessageType, Site} from "@/interface"
import API from "@/api"

@Component({components: {DatePicker, ErrorMessage}})
export default class NotificationCreate extends Vue {

  private title: string = ""
  private body: string = ""
  private url: string = ""
  private image: string = ""
  private reserve_at: string = moment().format("YYYY-MM-DD HH:mm")

  private load_ogp: boolean = false

  private is_confirm: boolean = false

  @Ref() uploadField!: HTMLInputElement

  private errors: {
    url?: string[],
    title?: string[],
    body?: string[],
    image?: string[]
    reserve_at?: string[]
  } = {}

  get site(): Site | null {
    return vxm.site.sites.find(s => s.id === vxm.app.selected_site_id) || null
  }

  async mounted() {
    const origin_id: string = <string>this.$route.query.origin_id
    if (origin_id) {
      await this.fillData(origin_id)
    }
  }

  async fillData(origin_id: string) {
    const data = await vxm.notification.fetchNotificationById(parseInt(origin_id))
    if (data) {
      this.title = data.notification.title
      this.body = data.notification.body
      this.url = data.notification.url
      this.image = data.notification.image || ""
      this.reserve_at = moment(data.notification.reserve_at).format("YYYY-MM-DD HH:mm")
    }
  }

  async onClickGetOGP() {
    try {
      this.load_ogp = true
      const response = await API.ogp({url: this.url})
      this.title = response.ogTitle || ""
      this.body = response.ogDescription || ""
      this.image = response.ogImage.url || ""

      const site = vxm.site.sites.find(site => site.id === vxm.app.selected_site_id)
      if (site) {
        const title_regexp    = site.title_regexp || null
          , title_replacement = site.title_replacement || ""
          , body_regexp       = site.body_regexp || null
          , body_replacement  = site.body_replacement || ""
        if (title_regexp !== null) {
          this.title = this.title.replace(new RegExp(title_regexp), title_replacement)
        }
        if (body_regexp !== null) {
          this.body = this.body.replace(new RegExp(body_regexp), body_replacement)
        }
      }
    } catch (e) {
      vxm.app.addFlushMessage({
        type   : FlushMessageType.ERROR,
        message: "An error has occurred"
      })
    } finally {
      this.load_ogp = false
    }
  }

  onConfirm() {

    this.errors = {}
    if (!this.validate()) return

    this.is_confirm = true
  }

  onBack() {
    this.is_confirm = false
  }

  onTest() {
    if (!window.Notification) {
      alert("このブラウザは対応していません。")
      return
    }

    Notification.requestPermission(result => {
      if (result === "denied") {
        alert("通知が許可されていません")
        return
      } else if (result === "default") {
        alert("通知可能か不明です")
        return
      }

      try {
        navigator.serviceWorker.getRegistration()
          .then(reg => {
            if (!reg) return
            const icon = vxm.site.sites.find(site => site.id === vxm.app.selected_site_id)?.image || undefined

            reg.showNotification(this.title, {
              body : this.body,
              icon : icon ? "https://push.asahiinteractive.com/" + icon : undefined,
              image: this.image
            })
          })
          .catch(err => alert("Service Worker registration error: " + err))

      } catch (err) {
        alert("Notification API error: " + err)
      }

    })
  }

  async onSave() {

    this.errors = {}
    if (!this.validate()) return

    try {
      await vxm.notification.create({
        site_id   : 0,
        url       : this.url,
        title     : this.title,
        body      : this.body,
        image     : this.image,
        reserve_at: moment(this.reserve_at).toISOString()
      })
      vxm.app.addFlushMessage({
        type   : FlushMessageType.SUCCESS,
        message: "Notification create successful"
      })
      await this.$router.push({name: "NotificationList"})
    } catch (e) {
      vxm.app.addFlushMessage({
        type   : FlushMessageType.ERROR,
        message: "An error has occurred"
      })
      console.error(e)
    }
  }

  validate(): boolean {

    const validation = new Validation({
      url       : {required: true},
      title     : {required: true},
      body      : {required: true},
      reserve_at: {required: true}
    })

    const check: boolean = validation.validate({
      url       : this.url,
      title     : this.title,
      body      : this.body,
      image     : this.image,
      reserve_at: this.reserve_at
    })

    if (!check) this.errors = validation.getErrors()

    return check
  }
}
